module.exports = __webpack_public_path__ + "lastSlideAlt.webp?4b771fc21e876fe67b63a11024267993";